export default "__VITE_ASSET__D_brLjs9__"